import { LIS_ONLY_ROUTES } from '$generated/lis_routes/lis_routes';
import type { TMarket } from '../market/types';
import { checkPathAgainstRegex, getPathToTestForRouteGuards } from './utils';

export const isLisOnlyRoute = (pathname: string, market: TMarket) =>
    checkPathAgainstRegex(LIS_ONLY_ROUTES, getPathToTestForRouteGuards(pathname, market));
